<template>
    <div class="gcmcn-card-gradient entity-details">
        <div class="" v-separator-link="200">
            <div class="feed-details-container gcmcn-card">
                <div class="feed-details">
                    <el-row :gutter="20">
                        <el-col :span="16">
                            <div class="details-title">Name</div>
                            <p>{{ feedResource.display_name }}</p>
                        </el-col>
                        <el-col :span="8">
                            <ns-loader
                                :to-load="toLoad"
                                :fetch-timer="3000"
                                @dataFetched="onDataFetched"
                            >
                                <div slot="loader"></div>
                                <div
                                    class="text-right"
                                    slot="content"
                                >
                                    <el-button
                                        :loading="loading"
                                        :disabled="loading || disableEditOrDelete"
                                        type="primary"
                                        class="gcmcn-primary-btn small"
                                        @click="editFeedResource"
                                        style="margin-right: 10px;"
                                    >Edit</el-button>
                                    <el-button
                                        :loading="loading"
                                        :disabled="loading || disableEditOrDelete"
                                        type="danger"
                                        class="gcmcn-danger-btn small"
                                        @click="openConfirmModal"
                                    >Delete</el-button>
                                </div>
                            </ns-loader>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <div class="details-title">AWS Regions</div>
                            <div v-if="feedResource.delivery_aws_regions_uid.length > 0">
                                <p v-for="uid in feedResource.delivery_aws_regions_uid">
                                    {{ feedResourceRegion(uid) }}
                                </p>
                            </div>
                            <p
                                v-else
                            >
                                No regions
                            </p>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <div class="details-title">Universe</div>
                            <p>{{ universe ? universe.display_name : '' }}</p>
                        </el-col>
                    </el-row>
                    <div class="details-title">Redundancy</div>
                    <p>
                        {{ feedResource.redundancy_type }}
                    </p>
                    <div class="details-title">Description</div>
                    <p class="details--description">{{ feedResource.description }}</p>
                </div>
            </div>
        </div>
        <gcmcn-modal
            :show="displayConfirmModal"
            :close-on-click-modal="canCloseModal"
        >
            <template #default v-if="hasDeletionErrors">
                <div class="gcmcn-modal__title">
                    <i class="el-icon-warning icon"></i>
                    Can't delete feed resource
                </div>
                <div class="gcmcn-modal__body">
                    <vue-markdown
                        :source="deletionErrors"
                    ></vue-markdown>
                </div>
                <div class="gcmcn-modal__buttons">
                    <el-link
                        @click="closeConfirmModal"
                    >
                        Ok
                    </el-link>
                </div>
            </template>
            <template #default v-else>
                <loader
                    v-if="loading"
                ></loader>
                <div class="gcmcn-modal__title">
                    <i class="el-icon-warning icon"></i>
                    Delete feed resource
                </div>
                <div class="gcmcn-modal__body">
                    This action will be immediate and can't be undone. <br>
                    <div class="confirmed-resource-deletion">
                        Please type the
                        <span
                            style="display: inline-block; text-transform: uppercase;"
                        >
                            "{{feedResource.display_name}}"
                        </span>
                        to delete resource :
                        <el-input
                            v-model="confirmChannelDeletionValue"
                            class="gcmcn-form-input confirm-input"
                        ></el-input>
                    </div>
                </div>
                <div class="gcmcn-modal__buttons">
                    <el-link
                        @click="closeConfirmModal"
                    >
                        No
                    </el-link>
                    <el-button
                        type="danger"
                        size="mini"
                        :disabled="checkResourceDeleteConfirmation"
                        @click="createDeleteRequest"
                    >
                        Yes
                    </el-button>
                </div>
            </template>
        </gcmcn-modal>
    </div>
</template>

<script>
import GcmcnModal from '@/components/gcmcn-modal-theme.vue';
import Loader from '@/components/loader-template.vue';
import VueMarkdown from 'vue-markdown';
import NsLoader from 'fundation-app-vuejs/src/components/partials/ns-vue-loaderV2.vue';
import {mapGetters} from 'vuex';
export default {

    name: 'FeedResourceDetails',
    components:{
        GcmcnModal,
        Loader,
        VueMarkdown,
        NsLoader
    },
    props:{
        feedResource:{
            type: Object,
            required: true,
        },
        universe:{
            type: Object,
            required: true,
        },
    },
    data () {
        return {
            loading: false,
            displayConfirmModal: false,
            hasDeletionErrors: false,
            request: null,
            deletionErrors: '',
            createdRequestUid:'',
            confirmChannelDeletionValue:'',
        };
    },
    computed:{
        ...mapGetters([
            'entitiesByUid',
            'userIsAtLeastAdmin',
            'userIsEntityAdmin',
            'awsregionsByUid'
        ]),
        toLoad(){
            return[{
                name:'request',
                model:'feedResourceModificationRequests',
                filters:{
                    feed_resource_uid: this.feedResource.uid,
                    status__in: ['PENDING', 'RUNNING']
                }
            }];
        },
        disableEditOrDelete(){
            if(this.entity !== ''){
                return !this.userIsEntityAdmin(this.entity.uid) && !this.userIsAtLeastAdmin;
            }
            return !this.userIsAtLeastAdmin;
        },
        checkResourceDeleteConfirmation(){
            return this.confirmChannelDeletionValue.toLowerCase() !== this.feedResource.display_name.toLowerCase();
        },
        entity(){
            if(this.feedResource){
                return this.entitiesByUid(this.feedResource.scopes.entity_uid);
            }
            return '';
        },
        canCloseModal(){
            return !this.loading;
        }
    },
    watch:{
        request(val){
            if(val && val.uid !== this.createdRequestUid){
                this.loading = true;
                this.watchRequest(val);
            }
        }
    },
    methods:{
        onDataFetched(res){
            this.$set(this, 'request', res.request[0] || null);
        },
        editFeedResource(){
            this.$emit('on-update-feed-resource', this.feedResource);
        },
        openConfirmModal(){
            this.displayConfirmModal = true;
        },
        createDeleteRequest(){
            this.loading = true;
            this.$store.dispatch('createItem', {
                item:{
                    feed_resource_uid: this.feedResource.uid,
                    action: 'DELETE',
                    status: 'PENDING',
                },
                model:'feedResourceModificationRequests',
                url: this.$store.state.api.meta.listModels.feedResourceModificationRequests.url,
                scopes: {'X-Entity-Uid': this.entity.uid}
            }).then(res => {
                this.$set(this, 'createdRequestUid', res.uid);
                this.watchRequest(res);
            }).catch(() =>{
                this.loading = false;
                this.$notify.success({
                    message : `Error while trying to delete "${this.feedResource.display_name}", please retry.`,
                });
            });

        },
        watchRequest(request){
            this.$store.dispatch('fundation/watchRequestStatus',{
                url: request.url,
            }).then(()=>{
                if(this.displayConfirmModal){
                    this.$notify.success({
                        message : `Feed resources "${this.feedResource.display_name}" deleted with success`,
                    });
                    this.closeConfirmModal();
                }
                this.$set(this, 'createdRequestUid', '');
                this.loading = false;
            }).catch(response => {
                if(this.displayConfirmModal){
                    this.$set(this, 'hasDeletionErrors', true);
                    this.$set(this, 'deletionErrors', response.data.verbose_status);
                }
                this.$set(this, 'createdRequestUid', '');
                this.loading = false;
            });
        },
        closeConfirmModal(){
            this.displayConfirmModal = false;
            this.$set(this, 'hasDeletionErrors', false);
            this.$set(this, 'deletionErrors', '');
            this.$set(this, 'confirmChannelDeletionValue', '');
            this.$emit('trigger-refresh');
        },
        feedResourceRegion(uid){
            return this.awsregionsByUid(uid).display_name;
        }
    }
};
</script>

<style lang="scss">
    .gcmcn-modal{
        .el-dialog__body{
            color: white;
            .gcmcn-modal__title{
                margin-bottom: 2rem;
                .icon{
                    color: #E6A23C;
                }
            }
            .gcmcn-modal__body{
                text-transform: none;
                margin-bottom: 2rem;
                .confirmed-resource-deletion{

                    background-color: #E6A23C;
                    padding: 2rem;
                    margin: 2rem;
                    border-radius: 5px;
                }
                .confirm-input{
                    margin-top: 1rem;
                }
            }
            .gcmcn-modal__buttons{
                display: flex;
                justify-content: flex-end;
                .el-link{
                    position: static;
                    color: white;
                    text-transform: none;
                    margin-right: 1rem;
                    &.is-underline:hover:after{
                        border-bottom: none;
                    }
                }
            }
            .loading-spinner-container{
                position: absolute;
                height: 100%;
                width: 100%;
                top: 0;
                left: 0;
                background-color: rgba(0, 0, 0, 0.8);
                display: flex;
                justify-content: center;
                align-items: center;
                z-index: 99;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/page/FeedResources/feedResourceDetails/feed-resource-details.vue